export interface DebouncerParams {
   /** debounce time value */
   debounce?: number
}
export default class Debouncer {
   timeout?: NodeJS.Timeout
   private params
   private pendingCall?: () => any

   constructor(params: DebouncerParams = {}) {
      this.params = params
   }

   run = (func: () => any, debounce?: number) => {
      this.clear()
      this.pendingCall = func
      this.timeout = setTimeout(() => {
         this.timeout = undefined
         this.pendingCall = undefined
         func()
      }, debounce ?? this.params.debounce ?? 300)
   }

   /** Runs the call still waiting on the timer, now, and cancels the timer. */
   flush = async () => {
      const pendingCall = this.pendingCall
      this.clear()

      if (pendingCall) {
         await pendingCall()
      }
   }

   clear = () => {
      this.pendingCall = undefined
      if (!!this.timeout) {
         clearTimeout(this.timeout)
         this.timeout = undefined
      }
   }
}
